/** OPTION C — Lifecycle Signature. Typography-led, centred, no illustrations. */
import { ArrowRight, Loader2, ChevronLeft } from "lucide-react";
import { useLoginAuth } from "./useLoginAuth";

const STAGES = ["Procure","Deploy","Manage","Support","Recover","Reuse","Recycle"];

export default function OptionC() {
  const a = useLoginAuth();
  return (
    <div className="min-h-screen bg-[color:var(--st-bg)] grid place-items-center px-8 py-16" data-testid="login-option-c">
      <div className="w-full max-w-[520px] text-center">
        <div className="text-[13px] font-semibold tracking-[0.16em] text-[color:var(--st-text)]">SUNTRONIX ONE</div>
        <h1 className="mt-16 font-heading text-[40px] leading-[1.1] tracking-[-0.02em] text-[color:var(--st-text)] font-medium">
          One platform.<br /><span className="text-[color:var(--st-text-muted)] font-normal">Every technology lifecycle.</span>
        </h1>

        <div className="mt-14 space-y-1 text-[11px] uppercase tracking-[0.28em] text-[color:var(--st-text-muted)]">
          {STAGES.map((s, i) => (
            <div key={s}>
              <div className="py-2.5">{s}</div>
              {i < STAGES.length - 1 && <div className="mx-auto h-px w-16 bg-[color:var(--st-border-strong)]" />}
            </div>
          ))}
        </div>

        <div className="mt-16 text-left max-w-[340px] mx-auto">
          <div className="text-[11px] uppercase tracking-[0.14em] text-[color:var(--st-text-muted)] text-center">
            Access your organisation
          </div>
          {a.step === "email" ? (
            <form onSubmit={a.continueEmail} className="mt-6 space-y-4">
              <input type="email" required autoFocus value={a.email}
                onChange={(e) => a.setEmail(e.target.value)}
                placeholder="Work email"
                className="w-full h-12 px-0 border-0 border-b border-[color:var(--st-border-strong)] bg-transparent text-[17px] text-center focus:outline-none focus:border-[color:var(--st-text)] placeholder:text-[color:var(--st-text-hint)]"
                data-testid="c-email" />
              {a.error && <div role="alert" className="text-[12px] text-[color:var(--st-critical)] text-center">{a.error}</div>}
              <button type="submit" disabled={a.loading || !a.email}
                className="mx-auto flex items-center gap-2 text-[12px] uppercase tracking-[0.24em] text-[color:var(--st-text)] hover:text-[color:var(--st-accent)] disabled:opacity-50 py-2"
                data-testid="c-continue">
                {a.loading ? <Loader2 className="h-4 w-4 animate-spin"/> : (<>Continue <ArrowRight className="h-4 w-4" strokeWidth={1.6}/></>)}
              </button>
            </form>
          ) : (
            <form onSubmit={a.submitPassword} className="mt-6 space-y-4">
              <button type="button" onClick={a.backToEmail} className="mx-auto text-[11px] text-[color:var(--st-text-muted)] hover:text-[color:var(--st-text)] inline-flex items-center gap-1">
                <ChevronLeft className="h-3 w-3"/> {a.email}
              </button>
              <input type="password" required autoFocus value={a.password}
                onChange={(e) => a.setPassword(e.target.value)} placeholder="Password"
                className="w-full h-12 px-0 border-0 border-b border-[color:var(--st-border-strong)] bg-transparent text-[17px] text-center focus:outline-none focus:border-[color:var(--st-text)] placeholder:text-[color:var(--st-text-hint)]"/>
              {a.error && <div role="alert" className="text-[12px] text-[color:var(--st-critical)] text-center">{a.error}</div>}
              <button type="submit" disabled={a.loading}
                className="mx-auto flex items-center gap-2 text-[12px] uppercase tracking-[0.24em] text-[color:var(--st-text)] hover:text-[color:var(--st-accent)] disabled:opacity-50 py-2">
                {a.loading ? <Loader2 className="h-4 w-4 animate-spin"/> : "Sign in"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
